<template>
  <v-container
    fluid
  >
    <v-row
      justify="center"
      class="ma-0"
    >
      <user-profile />
    </v-row> 
    <v-row
      justify="center"
      class="ma-0"
    >
      <my-plan/>
    </v-row>    
    <v-spacer
      class="my-4"
    />
    <v-row
      justify="center"
      class="ma-0"
    >
      <my-storage/>
    </v-row>    
    <v-spacer
      class="my-4"
    />    
    <!-- <v-row
      justify="center"
      class="ma-0"
      v-if="!chargeTypeIsCredits"
    >
      <my-packages/>
    </v-row>    
    <v-spacer
      class="my-4"
    />
    <v-row
      justify="center"
      class="ma-0"
    >
      <transactions/>
    </v-row> -->
  </v-container>
</template>

<script>
  // import Transactions from "../../components/MyAccount/Transactions"
  import MyPlan from "../../components/MyAccount/MyPlan"
  // import MyPackages from "../../components/MyAccount/MyPackages"
  import UserProfile from "../../components/MyAccount/UserProfile"
  import MyStorage from "../../components/MyAccount/MyStorage"

  export default {
    name: "MyAccount",
    components: {MyPlan, /*MyPackages, Transactions,*/ UserProfile, MyStorage },
    computed: {
      chargeTypeIsCredits() {
        if (this.$subsMng.subscriptionPlan?.["str_charge_type_system"] == 'credits')
          return true
        return false
      },
    }
  }
</script>

<style scoped>

</style>
